import React from 'react'
import classNames from 'classnames'

import { ButtonListProps } from './ButtonList.schema'

import Button from '@/button/Button'

const ButtonList = (props: ButtonListProps) => {
    const className = classNames('button-list', props.className)

    return (
        <ul className={className}>
            {props.buttons && props.buttons.map((button, index) => (
                <li className='button-list__item' key={index}>
                    <Button className='button-list__button' {...button} />
                </li>
            ))}
        </ul>
    )
}

export default ButtonList
